import { render, staticRenderFns } from "./RevenuesTypesTable.vue?vue&type=template&id=19f483d9&"
import script from "./RevenuesTypesTable.vue?vue&type=script&lang=js&"
export * from "./RevenuesTypesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports